module.exports = __webpack_public_path__ + "static/media/petzenpro-4.f0703fb8.jpg";